import { ReferenceInput, AutocompleteInput, required, useTranslate } from 'react-admin';
import { useWatch } from 'react-hook-form';
import { Box, Typography } from '@mui/material';
import { serviceCompanyFilterToQuery } from '@/helpers/filters/filterToQuery.js';
import { roleIsService } from '@/constants/Roles.js';

export const ServiceCompanyInput = () => {
    const role = useWatch({ name: 'role' });
    const translate = useTranslate();
    return (
        roleIsService(role) && (
            <Box className='padding-wrapper'>
                <Typography variant='h6' gutterBottom sx={{ marginBottom: '23px' }}>
                    {translate('resources.user.labels.assignToServiceSection')}
                </Typography>
                <Box className='autocomplete-parent'>
                    <ReferenceInput source='serviceCompanyId' reference='service-company' perPage={25}>
                        <AutocompleteInput
                            filterToQuery={serviceCompanyFilterToQuery}
                            fullWidth
                            validate={required(translate('common.validation.required'))}
                            label={translate('resources.user.fields.serviceCompanyId')}
                            disablePortal={true}
                        />
                    </ReferenceInput>
                </Box>
            </Box>
        )
    );
};
